import { DownloadOutlined, UploadOutlined } from "@ant-design/icons";
import { Button, Input, Select, Upload } from "antd";
import { FaPlus } from "react-icons/fa6";
import { EditorState } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { useState } from "react";



function RegisterEmployer() {
    const [editorState, setEditorState] = useState(() => EditorState.createEmpty());
    const [logo, setLogo] = useState("");
    const [benner1, setBenner1] = useState("");
    const [benner2, setBenner2] = useState("");
    const [benner3, setBenner3] = useState("");


    function handleChange(file, type) {

        if (file) {
            switch (type) {
                case 'logo':
                    setLogo(URL.createObjectURL(file));
                    break;
                case 'benner1':
                    setBenner1(URL.createObjectURL(file));
                    break;
                case 'benner2':
                    setBenner2(URL.createObjectURL(file));
                    break;
                case 'benner3':
                    setBenner3(URL.createObjectURL(file));
                    break;
                default:
                    break;
            }
        }
    }



    return (
        <section className="container xl:container flex flex-col mx-auto p-4 lg:p-8 ">
            <div>
                <h1 className="text-4xl font-semibold text-center mb-2">Đăng ký thông tin công ty</h1>
                <p className="text-center font-semibold mb-6">Đăng ký thông tin để trải nghiệm các tiện ích hữu ích của "Việc Làm Sản Xuất".</p>
            </div>
            <div>
                <div className=" md:grid grid-cols-2 gap-x-8">
                    <div className="mb-2.5">
                        <p className="font-semibold mb-1">Họ và Tên <span className="text-red-500">(*)</span></p>
                        <Input className=" h-12 w-full  rounded-md" placeholder="VD: Nguyễn Văn A" />
                    </div>
                    <div className="mb-2.5">
                        <p className="font-semibold mb-1">Điện thoại <span className="text-red-500">(*)</span></p>
                        <Input className=" h-12 w-full  rounded-md" placeholder="VD: 0905123456" />
                    </div>
                    <div className="mb-2.5">
                        <p className="font-semibold mb-1">Email <span className="text-red-500">(*)</span></p>
                        <Input className=" h-12 w-full  rounded-md" placeholder="VD: nguyenvana@gmail.com" />
                    </div>
                    <div className="mb-2.5">
                        <p className="font-semibold mb-1">Chức vụ</p>
                        <Select
                            className="w-full h-12  "
                            // showSearch
                            // filterOption={(input, option) => option.value.toLowerCase().includes(input.toLowerCase())}
                            dropdownRender={(menu) => (
                                <div>
                                    <div className="p-2 ">
                                        <Input
                                            className="p-2"
                                            placeholder="Tìm kiếm"
                                        />
                                    </div>
                                    <div>{menu}</div>
                                </div>
                            )}
                            options={[
                                { lable: "a", value: 'a' },
                                { lable: "a", value: 'a' },
                                { lable: "a", value: 'a' },
                                { lable: "a", value: 'a' },
                            ]}
                            optionFilterProp={"label"}
                            placeholder={"Lựa chọn vùng miền"}
                        />
                    </div>
                    <div className="mb-2.5">
                        <p className="font-semibold mb-1">Tên công ty <span className="text-red-500">(*)</span></p>
                        <Input className=" h-12 w-full  rounded-md" placeholder="Nhập tên công ty" />
                    </div>
                    <div className="mb-2.5">
                        <p className="font-semibold mb-1">Địa chỉ công ty <span className="text-red-500">(*)</span></p>
                        <Input className=" h-12 w-full  rounded-md" placeholder="Nhập địa chỉ công ty" />
                    </div>
                    <div className="mb-2.5">
                        <p className="font-semibold mb-1">Quy mô nhân sự <span className="text-red-500">(*)</span></p>
                        <Select
                            className="w-full h-12  "
                            // showSearch
                            // filterOption={(input, option) => option.value.toLowerCase().includes(input.toLowerCase())}
                            dropdownRender={(menu) => (
                                <div>
                                    <div className="p-2 ">
                                        <Input
                                            className="p-2"
                                            placeholder="Tìm kiếm"
                                        />
                                    </div>
                                    <div>{menu}</div>
                                </div>
                            )}
                            options={[
                                { lable: "a", value: 'a' },
                                { lable: "a", value: 'a' },
                                { lable: "a", value: 'a' },
                                { lable: "a", value: 'a' },
                            ]}
                            optionFilterProp={"label"}
                            placeholder={"Chọn quy mô nhân sự"}
                        />
                    </div>
                    <div className="mb-2.5">
                        <p className="font-semibold mb-1">Mã số doanh nghiệp <span className="text-red-500">(*)</span></p>
                        <Input className=" h-12 w-full  rounded-md" placeholder="Nhập mã số thuế" />
                    </div>
                    <div className="mb-2.5">
                        <p className="font-semibold mb-1">Tỉnh thành  <span className="text-red-500">(*)</span></p>
                        <Select
                            className="w-full h-12  "
                            // showSearch
                            // filterOption={(input, option) => option.value.toLowerCase().includes(input.toLowerCase())}
                            dropdownRender={(menu) => (
                                <div>
                                    <div className="p-2 ">
                                        <Input
                                            className="p-2"
                                            placeholder="Tìm kiếm"
                                        />
                                    </div>
                                    <div>{menu}</div>
                                </div>
                            )}
                            options={[
                                { lable: "a", value: 'a' },
                                { lable: "a", value: 'a' },
                                { lable: "a", value: 'a' },
                                { lable: "a", value: 'a' },
                            ]}
                            optionFilterProp={"label"}
                            placeholder={"Chọn tỉnh thành"}
                        />
                    </div>
                    <div className="mb-2.5">
                        <p className="font-semibold mb-1">Nghề nghiệp  <span className="text-red-500">(*)</span></p>
                        <Select
                            className="w-full h-12  "
                            // showSearch
                            // filterOption={(input, option) => option.value.toLowerCase().includes(input.toLowerCase())}
                            dropdownRender={(menu) => (
                                <div>
                                    <div className="p-2 ">
                                        <Input
                                            className="p-2"
                                            placeholder="Tìm kiếm"
                                        />
                                    </div>
                                    <div>{menu}</div>
                                </div>
                            )}
                            options={[
                                { lable: "a", value: 'a' },
                                { lable: "a", value: 'a' },
                                { lable: "a", value: 'a' },
                                { lable: "a", value: 'a' },
                            ]}
                            optionFilterProp={"label"}
                            placeholder={"Chọn lĩnh vực"}
                        />
                    </div>
                    <div className="mb-2.5">
                        <p className="font-semibold mb-1">Điện thoại công ty</p>
                        <Input className=" h-12 w-full  rounded-md" placeholder="Nhập điện thoại" />
                    </div>
                    <div className="mb-2.5">
                        <p className="font-semibold mb-1">Email công ty</p>
                        <Input className=" h-12 w-full  rounded-md" placeholder="Nhập email" />
                    </div>
                    <div className="col-span-2 mb-2.5">
                        <p className="font-semibold mb-1">Logo công ty</p>
                        <div className="flex flex-col md:flex-row gap-6">
                            <div className="w-full md:w-64 h-40 flex justify-center items-center border rounded-md border-gray-200">
                                <img className="h-36" src={logo || 'https://vieclamsanxuat.com/img/icon_cpn.png'} alt="logo" />
                            </div>
                            <div className="flex flex-col items-start gap-2  ">
                                <Input
                                    hidden
                                    id="logo"
                                    type="file"
                                    onChange={(e) => handleChange(e.target.files[0], 'logo')}
                                />
                                <label htmlFor='logo' className=" text-white rounded-lg flex gap-2 px-8 py-2 bg-blue-500">
                                    <DownloadOutlined className="text-white" />
                                    Download
                                </label>
                                <p>
                                    Đăng hình dưới dạng tập tin PNG, JPG dung lượng không vượi quá 3MB</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-span-2 mb-2.5">
                        <p className="font-semibold mb-1">Benner công ty (tối đa 3 files)</p>
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-4"  >
                            <label htmlFor="benner1" className="p-4 w-full h-40 flex items-center justify-center border border-gray-300 rounded-md">
                                <Input
                                    hidden
                                    id="benner1"
                                    type="file"
                                    onChange={(e) => handleChange(e.target.files[0], 'benner1')}
                                />
                                {!benner1 && <FaPlus className="w-10 h-10" />}
                                {!!benner1 && <img className="w-full h-full object-contain" src={benner1} alt="benner1" />}
                            </label>
                            <label htmlFor="benner2" className="p-4 w-full h-40 flex items-center justify-center border border-gray-300 rounded-md">
                                <Input
                                    hidden
                                    id="benner2"
                                    type="file"
                                    onChange={(e) => handleChange(e.target.files[0], 'benner2')}
                                />
                                {!benner2 && <FaPlus className="w-10 h-10" />}
                                {!!benner2 && <img className="w-full h-full object-contain" src={benner2} alt="benner2" />}
                            </label>
                            <label htmlFor="benner3" className="p-4 w-full h-40 flex items-center justify-center border border-gray-300 rounded-md">
                                <Input
                                    hidden
                                    id="benner3"
                                    type="file"
                                    onChange={(e) => handleChange(e.target.files[0], 'benner3')}
                                />
                                {!benner3 && <FaPlus className="w-10 h-10" />}
                                {!!benner3 && <img className="w-full h-full object-contain" src={benner3} alt="benner3" />}
                            </label>

                        </div>
                    </div>
                    <div className="col-span-2 mb-2.5">
                        <p className="font-semibold mb-1">Chọn địa chỉ trên bản đồ</p>
                        <div className="w-full flex gap-2">
                            <Input className="h-12 w-full  rounded-md" placeholder="Dán kinh độ vĩ độ vào đây..." />
                            <Button className="h-12 w-24 text-lg font-semibold" type="primary">Lấy vị trí</Button>
                        </div>
                    </div>
                    <div className="col-span-2 mb-2.5">
                        <p className="font-semibold mb-1">Mô tả chi tiết về công ty</p>
                        <Editor
                            editorState={editorState}
                            onEditorStateChange={setEditorState}
                            wrapperClassName="border border-gray-200"
                            editorClassName="px-4 min-h-40 "
                            toolbarClassName=""
                            toolbar={{
                                options: [
                                    "inline", "blockType", "fontSize", "fontFamily", "list",
                                    "textAlign", "colorPicker", "link", "embedded", "emoji",
                                    "image", "remove", "history"
                                ],
                                fontFamily: {
                                    options: ["Arial", "Georgia", "Impact", "Tahoma", "Times New Roman", "Verdana"],
                                },
                                inline: { options: ["bold", "italic", "underline", "strikethrough", "monospace", "superscript", "subscript"] },
                                list: { options: ["unordered", "ordered", "indent", "outdent"] },
                                textAlign: { options: ["left", "center", "right", "justify"] },
                                colorPicker: { className: "color-picker" },
                                link: { options: ["link", "unlink"] },
                                history: { options: ["undo", "redo"] },
                            }}
                        />
                    </div>
                </div>
            </div>
        </section>
    );
}

export default RegisterEmployer;